__turbopack_context__.v({
  "change_station_panel": "ChangeStationPanel-module-scss-module__cxdByG__change_station_panel",
  "change_station_panel__buttons": "ChangeStationPanel-module-scss-module__cxdByG__change_station_panel__buttons",
  "change_station_panel__header": "ChangeStationPanel-module-scss-module__cxdByG__change_station_panel__header",
  "change_station_panel__stations_list": "ChangeStationPanel-module-scss-module__cxdByG__change_station_panel__stations_list",
});
